import { create } from "zustand";

interface DashboardStoreType {
  gridSizeData: GridSizeDataType;
  hoverColumnName: string;
  setGridSizeData: (data: GridSizeDataType) => void;
  setHoverColumnName: (columnName: string) => void;
  resetDashboardStore: () => void;
}
export interface GridSizeDataType {
  rows: number;
  columns: number;
  filterRows: number;
}

const useDashboardStore = create<DashboardStoreType>((set) => ({
  gridSizeData: {
    rows: 0,
    columns: 0,
    filterRows: 0,
  },
  hoverColumnName: "",
  setGridSizeData: (data: GridSizeDataType) => {
    set({ gridSizeData: data });
  },
  setHoverColumnName: (columnName: string) => {
    set({ hoverColumnName: columnName });
  },
  resetDashboardStore: () => {
    set({
      gridSizeData: {
        rows: 0,
        columns: 0,
        filterRows: 0,
      },
      hoverColumnName: "",
    });
  },
}));

export default useDashboardStore;
